var map = {
	"./9cloud_logo.png": 2862,
	"./banner/DataAnalytiikka-scaled.jpeg": 1520,
	"./banner/Efficiency-Productivity.jpg": 6150,
	"./banner/Efficiency-Productivity.webp": 2282,
	"./banner/Maintenance-as-a-Service.jpeg": 9045,
	"./banner/PS-Handshake-2000x1222.jpeg": 8064,
	"./mobile/icon_arrow_d.png": 5294,
	"./partners/1.png": 6255,
	"./partners/10.png": 5188,
	"./partners/11.png": 6049,
	"./partners/12.png": 9365,
	"./partners/13.png": 3293,
	"./partners/14.png": 3693,
	"./partners/15.png": 525,
	"./partners/16.png": 8841,
	"./partners/17.png": 8878,
	"./partners/18.png": 1649,
	"./partners/19.png": 7931,
	"./partners/2.png": 3154,
	"./partners/20.png": 4833,
	"./partners/21.png": 2211,
	"./partners/22.png": 5284,
	"./partners/23.png": 7429,
	"./partners/24.png": 8276,
	"./partners/25.png": 7217,
	"./partners/26.png": 5312,
	"./partners/27.png": 9461,
	"./partners/28.png": 8600,
	"./partners/29.png": 7329,
	"./partners/3.png": 7885,
	"./partners/30.png": 5242,
	"./partners/31.png": 5573,
	"./partners/32.png": 3929,
	"./partners/33.png": 8176,
	"./partners/34.png": 2171,
	"./partners/35.png": 1001,
	"./partners/36.png": 1394,
	"./partners/37.png": 7599,
	"./partners/38.png": 5938,
	"./partners/39.png": 430,
	"./partners/4.png": 2633,
	"./partners/40.png": 6696,
	"./partners/5.png": 5256,
	"./partners/6.png": 8377,
	"./partners/7.png": 5553,
	"./partners/8.png": 1370,
	"./partners/9.png": 5009,
	"./qrcode_for_gh_f5f081c2a6c2_344.jpeg": 7629,
	"./t5.png": 2627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;